import { create } from "zustand";

interface IncomingRingState {
  /** True while the incoming-call banner is showing an unanswered invite. */
  ringing: boolean;
  setRinging: (ringing: boolean) => void;
}

/**
 * Whether an incoming 1:1 call is ringing for the signed-in user right now.
 * Written only by IncomingCallBanner (which owns the invite poll); read it
 * with `useIsRinging()` instead of polling the direct-call endpoint again.
 */
export const useIncomingRingStore = create<IncomingRingState>((set) => ({
  ringing: false,
  setRinging: (ringing) => set((s) => (s.ringing === ringing ? s : { ringing })),
}));

export function useIsRinging(): boolean {
  return useIncomingRingStore((s) => s.ringing);
}
